import { UIElementIdType } from 'types/common.types';

export const getJ360ElementNode = (id: UIElementIdType): HTMLElement | null =>
  document.getElementById(id);
